import { OneKlicksFileSDK } from "../SDK/OneKlicksFileSDK";

/**
 * Download and upload a single image from a URL
 * @param {string} imageUrl - Direct URL to the image
 * @param {Function} setdata - Callback function to set data
 * @returns {Promise<Object>} Upload result
 */
async function downloadImage(imageUrl, setdata) {
  try {
    console.log("Processing image URL:", imageUrl);
    
    const root = "gallery";
    const status = "public";
    
    // Upload the image directly from URL
    const uploadResult = await OneKlicksFileSDK.uploadFileFromUrl(root, status, imageUrl);
    console.log("Upload result:", uploadResult);
    
    if (typeof setdata === 'function') {
      setdata([imageUrl]);
    }
    
    return uploadResult;
  } catch (error) {
    console.error("Error in downloadImage:", error);
    throw error;
  }
}

/**
 * Download and upload multiple images from an array of URLs
 * @param {Array<string>} imageUrls - Array of image URLs
 * @param {Function} setdata - Callback function to set data
 * @returns {Promise<Array>} Array of upload results
 */
async function downloadMultipleImages(imageUrls, setdata) {
  const results = [];
  
  try {
    console.log(`Processing ${imageUrls.length} images`);
    
    for (let index = 0; index < imageUrls.length; index++) {
      const imgUrl = imageUrls[index];
      try {
        console.log(`Processing image ${index + 1}/${imageUrls.length}:`, imgUrl);
        
        const root = "gallery";
        const status = "public";
        const uploadResult = await OneKlicksFileSDK.uploadFileFromUrl(root, status, imgUrl);
        
        results.push({
          index,
          url: imgUrl,
          result: uploadResult
        });
        
        console.log(`Image ${index + 1} upload result:`, uploadResult);
      } catch (err) {
        console.error(`Error uploading image at index ${index}:`, err);
        results.push({
          index,
          url: imgUrl,
          error: err.message
        });
      }
    }
    
    if (typeof setdata === 'function') {
      setdata(imageUrls);
    }
    
    return results;
  } catch (error) {
    console.error("Error in downloadMultipleImages:", error);
    throw error;
  }
}

/**
 * Extract image URLs from a webpage (client-side only, limited functionality)
 * Note: This is limited by CORS and same-origin policy
 * @param {string} pageUrl - URL of the page to extract images from
 * @returns {Promise<Array>} Array of image URLs found
 */
async function extractImageUrlsFromPage(pageUrl) {
  try {
    // Note: This will only work for same-origin pages due to CORS restrictions
    const response = await fetch(pageUrl);
    const html = await response.text();
    
    // Simple regex to find image URLs (basic implementation)
    const imgRegex = /<img[^>]+src=["']([^"']+)["']/gi;
    const imageUrls = [];
    let match;
    
    while ((match = imgRegex.exec(html)) !== null) {
      const imgUrl = match[1];
      if (imgUrl && !imgUrl.startsWith('data:')) {
        imageUrls.push(imgUrl);
      }
    }
    
    console.log(`Found ${imageUrls.length} images on page`);
    return imageUrls;
  } catch (error) {
    console.error("Error extracting image URLs from page:", error);
    console.warn("Note: This function is limited by CORS policies and will only work for same-origin pages");
    return [];
  }
}

export { downloadImage, downloadMultipleImages, extractImageUrlsFromPage };
export default downloadImage;
